import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { cn } from '../../../utils/utils';
import CrossIcon from '../../../icons/cross';
import { DIALOG_LAYER } from '../layers';
export const DialogRoot = Dialog.Root;
export const DialogTrigger = Dialog.Trigger;
export const DialogPortal = Dialog.Portal;
export const DialogClose = Dialog.Close;
export const DialogBackdrop = ({ className, ...props }) => {
    return (_jsx(Dialog.Backdrop, { ...props, className: cn(DIALOG_LAYER, 'fixed inset-0 bg-black opacity-20 transition-all duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0', className) }));
};
// `size` is the only sanctioned width: sm for a confirm, md for a short form, lg for
// a long one. Omitting it keeps the pre-size behaviour (width from the content) so
// existing dialogs don't move; new dialogs always pass one.
export const DialogPopup = ({ children, className, size, ...props }) => {
    return (_jsx(Dialog.Popup, { ...props, className: cn(DIALOG_LAYER, 'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 outline outline-gray-50 rounded-lg bg-white p-6 font-roobert transition-all duration-150 data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0 shadow-sm', {
            'w-[26rem] max-w-[calc(100vw-2rem)]': size === 'sm',
            'w-[28rem] max-w-[calc(100vw-2rem)]': size === 'md',
            'w-[32rem] max-w-[calc(100vw-2rem)]': size === 'lg'
        }, className), children: children }));
};
export const DialogTitle = ({ className, ...props }) => {
    return (_jsx(Dialog.Title, { ...props, className: cn('font-roobert text-lg font-medium', className) }));
};
export const DialogDescription = ({ className, ...props }) => {
    return (_jsx(Dialog.Description, { ...props, className: cn('text-sm font-normal leading-relaxed text-neutral-600', className) }));
};
export const DialogHeader = ({ className, ...props }) => {
    return _jsx("header", { ...props, className: cn('space-y-1', className) });
};
export const DialogFooter = ({ className, ...props }) => {
    return (_jsx("div", { ...props, className: cn('flex justify-end gap-2', className) }));
};
// Anchors to the popup itself, which is `fixed` and so already a containing block —
// no positioned wrapper needed around the dialog's content.
export const DialogCloseButton = ({ className, children, 'aria-label': ariaLabel = 'Close', ...props }) => {
    return (_jsx(Dialog.Close, { "aria-label": ariaLabel, ...props, className: cn('absolute right-3 top-3 rounded-sm p-1.5 transition-colors hover:bg-neutral-200/50', className), children: children ?? _jsx(CrossIcon, { "aria-hidden": "true" }) }));
};
